<div class="modal-content preview-modal">
  <p class="preview-modal__text">This functionality is not available in preview mode.</p>
  <button class="apply-btn btn btn--default" (click)="close()">Got it</button>
</div>
